export default function videoPlayer() {
	// Select all video elements on site
	/* eslint-disable no-undef */
	const wpBlocksVideo = document.querySelectorAll('.wp-block-video');
	console.log(wpBlocksVideo);


	// Check if there are any video elements
	if (!wpBlocksVideo.length) {
		return;
	}

	wpBlocksVideo.forEach((videoBlock) => {
		const video = videoBlock.firstChild

		if (video.getAttribute("poster") && !videoBlock.classList.contains("started")) {
			video.controls = false;

			video.addEventListener('click', function(){
				videoBlock.classList.add("started")
				video.controls = true;
		}, false);
		}
	});
}
